import { useContext } from "react";

import IBoundsContext from "../types/IBoundsContext";

import BoundsContext from "./BoundsContext";

const useBoundsContext = () => useContext(BoundsContext) as unknown as IBoundsContext;

export default useBoundsContext;
